class EnvService {
  private nodeEnv: string;

  constructor() {
    const { origin } = window.location;
    this.nodeEnv = origin.includes('yodoor.com') ? 'production' : 'development';
  }

  get isProduction() {
    return this.nodeEnv === 'production';
  }

  get getDeffoultUrl() {
    return !this.isProduction
      ? 'https://api.yocerebrum.com/api/v1/'
      : 'https://st-api.yocerebrum.com/api/v1/';
  }

  get getApiUrl() {
    const url = process.env.REACT_APP_API_URL_v2 || this.getDeffoultUrl;
    return url;
  }

  get socketPort() {
    return this.isProduction ? 2577 : 2567;
  }

  get getSocketApiUrl() {
    const { origin } = window.location;
    if (origin.includes('localhost')) {
      return origin.replace(window.location.port, `${this.socketPort}/socket`);
    }
    if (origin.includes('yodoor')) {
      return 'https://yodoor.com/media-api/socket';
    } else {
      return 'https://expo.fastexverse.com/media-api/socket';
    }
  }

  get getAppApiUrl() {
    const { origin } = window.location;
    if (origin.includes('localhost')) {
      return origin.replace(window.location.port, `${this.socketPort}/app`);
    }
    if (origin.includes('yodoor')) {
      return 'https://yodoor.com/media-api/app';
    } else {
      return 'https://expo.fastexverse.com/media-api/app';
    }
  }
}

// Example usage
const envService = new EnvService();
export { envService };
